import { render, staticRenderFns } from "./InactivePropertyList.vue?vue&type=template&id=09196f00&"
import script from "./InactivePropertyList.vue?vue&type=script&lang=js&"
export * from "./InactivePropertyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports